import { BulkResizeDownloadState } from "./types";

export const initialState: BulkResizeDownloadState = {
    jobs: [],
    isExporting: false,
    isProcessing: true,
    downloadUrl: "",
};
